/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B100200 ゾーン管理マスタメンテ
 */
import {
  B000223BatchNm,
  B100200Create,
  B100200CreateRequest,
  B100200Delete,
  B100200DeleteRequest,
  B100200Update,
  B100200UpdateRequest,
  catchRestError,
} from "clients/rest";
import {
  msgState,
  SCancelButton,
  SCodeSelect,
  SConfirmDialog,
  SFileButton,
  SFrame,
  SLabel,
  SNormalButton,
  SNumberField,
  SText,
  STextField,
} from "components";
import { getClientMessage } from "messages";
import { Floor, getSCode, Mode, SCode } from "messages/codes";
import { labels } from "messages/labels";
import { B100910 } from "pages";
import { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { mode } from "services/codes";
import { focusState, useFocus } from "states";

// 呼び出し時のプロパティ
type Props = Partial<{
  // 呼び出し元へデータを送る場合に設定する。
  handleSubmit: (data: any) => void;
}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  modeKbn: SCode;
  zoneCd: string;
  zoneNm: string;
  zoneNmKana: string;
  floor: SCode;
  version: number;
}>;

// フィールドの初期値を設定する。
const defaultFields: Fields = {
  modeKbn: getSCode(Mode, "0"),
  zoneCd: "",
  zoneNm: "",
  zoneNmKana: "",
  floor: getSCode(Floor, "1"),
  version: undefined,
};

const focusId = "B100200";
// 画面ID
const gamenId = "100200";

// B100200 ゾーン管理マスタメンテ
export const B100200 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

const Page = (props: Props) => {
  // 状態管理の初期設定
  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });

  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));
  // エラー表示
  const setMsg = useSetRecoilState(msgState);
  // 画面遷移
  const navigate = useNavigate();
  // 更新確認ダイアログオープン用
  const [openUpdateConfirm, setOpenUpdateConfirm] = useState(false);
  // 活性設定
  // 新規モードかどうか
  const isShinki = methods.watch("modeKbn")?.value === mode.shinki;
  // 修正モードかどうか
  const isShusei = methods.watch("modeKbn")?.value === mode.shusei;
  // 削除モードかどうか
  const isSakujo = methods.watch("modeKbn")?.value === mode.sakujo;

  // 初期表示イベント
  useEffect(() => {
    focus(1);
  }, []);

  // 登録
  const handleCreate = () => {
    setOpenUpdateConfirm(false);

    const fields = methods.getValues();

    // // 登録するデータの作成
    // const param: B100200CreateRequest = {
    //   zoneCd: fields.zoneCd!,
    //   zoneNm: fields.zoneNm!,
    //   zoneNmKana: fields.zoneNmKana!,
    //   floor: fields.floor!,
    // };

    // B100200Create(param)
    //   .then(() => {
    //     // フィールドの初期化
    //     methods.reset();
    //     // ↓これがあると完了メッセージが表示される
    //     methods.setValue("haisorouteNo", "");
    //     // 登録完了メッセージ表示
    //     setMsg(getClientMessage("B100200_001"));
    //   })
    //   .catch((reason) => {
    //     catchRestError(reason, navigate, setMsg);
    //   });
  };

  // 更新
  const handleUpdate = () => {
    setOpenUpdateConfirm(false);

    const fields = methods.getValues();

    // // 更新するデータの作成
    // const param: B100200UpdateRequest = {
    //   zoneCd: fields.zoneCd!,
    //   zoneNm: fields.zoneNm!,
    //   zoneNmKana: fields.zoneNmKana!,
    //   floor: fields.floor!,
    //   version: fields.version!,
    // };

    // B100200Update(param)
    //   .then(() => {
    //     // フィールドの初期化
    //     methods.reset();
    //     // ↓これがあると完了メッセージが表示される
    //     methods.setValue("haisorouteNo", "");
    //     // 更新完了メッセージ表示
    //     setMsg(getClientMessage("B100200_002"));
    //   })
    //   .catch((reason) => {
    //     catchRestError(reason, navigate, setMsg);
    //   });
  };

  // 削除
  const handleDelete = () => {
    setOpenUpdateConfirm(false);

    const fields = methods.getValues();

    // // 削除するデータの作成
    // const param: B100200DeleteRequest = {
    //   zoneCd: fields.zoneCd!,
    // };

    // B100200Delete(param)
    //   .then(() => {
    //     // フィールドの初期化
    //     methods.reset();
    //     // ↓これがあると完了メッセージが表示される
    //     methods.setValue("zoneCd", "");
    //     // 削除完了メッセージ表示
    //     setMsg(getClientMessage("B100200_003"));
    //   })
    //   .catch((reason) => {
    //     catchRestError(reason, navigate, setMsg);
    //   });
  };

  const handleChangeMode = () => {
    // 条件をisSakujoにすると、セレクトボックス切り替え時に即座に値がクリアされない
    if (methods.watch("modeKbn")?.value === mode.sakujo) {
      methods.setValue("zoneNm", "");
      methods.setValue("zoneNmKana", "");
      methods.setValue("floor", getSCode(Floor, "1"));
    }
  };

  const handleChangeZoneCd = () => {
    if (isShinki) {
      return;
    } else {
      (async () => {
        // await B100230HaisorouteUsedByB100224(methods, navigate, setMsg);
        // await B000223BatchNm(methods, navigate, setMsg);
      })();
    }
  };

  // レイアウト設定
  return (
    <>
      <FormProvider {...methods}>
        <SFrame
          title="ゾーン管理マスタメンテ"
          gridTemplateColumns="9rem 6rem 13rem 2rem 6rem 8rem 13rem 5rem"
        >
          <SText gridColumn="span 7"></SText>
          <SFileButton
            label={labels.buttons.excel}
            align="right"
            {...register(7)}
            dialog={<B100910 gamenId={gamenId} />}
          />
          <SLabel required gridColumn="1">
            モード
          </SLabel>
          <SCodeSelect
            required
            name="modeKbn"
            label="モード"
            options={Mode}
            onChange={() => handleChangeMode()}
            {...register(1)}
          />

          <SLabel required gridColumn="1">
            ゾーンコード
          </SLabel>
          <STextField
            name="zoneCd"
            label="ゾーンコード"
            code="true"
            required
            size={2}
            {...register(2)}
            onBlur={() => {
              handleChangeZoneCd();
            }}
          />

          <SLabel gridColumn="1">ゾーン名</SLabel>
          <STextField
            name="zoneNm"
            label="ゾーン名"
            code
            size={20}
            {...register(3)}
            disabled={isSakujo}
            gridColumn="span 2"
          />

          <SLabel gridColumn="5">ゾーン名カナ</SLabel>
          <STextField
            name="zoneNmKana"
            label="ゾーン名カナ"
            size={20}
            {...register(4)}
            disabled={isSakujo}
            gridColumn="span 2"
          />

          <SText gridColumn="span 8">　</SText>

          <SLabel gridColumn="5">フロア</SLabel>
          <SCodeSelect
            required
            name="floor"
            label="フロア"
            options={Floor}
            {...register(5)}
            disabled={isSakujo}
          />

          {isShinki ? (
            <>
              <SNormalButton
                label={labels.buttons.create}
                align="right"
                gridColumn="8"
                gridRow="9"
                {...register(6)}
                dialog={
                  <SConfirmDialog
                    title={labels.dialog.createMasterTitle}
                    msg={labels.dialog.createConfirm}
                  />
                }
                dialogAction="confirm"
                handleSubmit={handleCreate}
              />
            </>
          ) : (
            <>
              {isShusei ? (
                <>
                  <SNormalButton
                    label={labels.buttons.update}
                    align="right"
                    gridColumn="8"
                    gridRow="9"
                    {...register(6)}
                    dialog={
                      <SConfirmDialog
                        title={labels.dialog.updateMasterTitle}
                        msg={labels.dialog.updateConfirm}
                      />
                    }
                    dialogAction="confirm"
                    handleSubmit={handleUpdate}
                  />
                </>
              ) : (
                <>
                  <SCancelButton
                    label={labels.buttons.delete}
                    align="right"
                    gridColumn="8"
                    gridRow="9"
                    {...register(6)}
                    dialog={
                      <SConfirmDialog
                        title={labels.dialog.deleteMasterTitle}
                        msg={labels.dialog.deleteConfirm}
                      />
                    }
                    dialogAction="confirm"
                    handleSubmit={handleDelete}
                  />
                </>
              )}
            </>
          )}
        </SFrame>
      </FormProvider>
    </>
  );
};
